/*
 * @Author: Tina Huang
 * @Date: 2025-02-12 17:33:44
 * @LastEditors: Tina Huang
 * @LastEditTime: 2025-02-13 14:28:13
 * @Description:
 */
import { ArrowRightOutlined, QuestionCircleOutlined, QuestionOutlined, SendOutlined } from '@ant-design/icons'
import { Button, FloatButton, Popover } from 'antd'
import { qaList } from '@/constants/qa'
import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

export default function Help() {
  const navigate = useNavigate()
  const handleMailTo = () => {
    window?.open('mailto:httishere0728@gmail.com', 'emailWindow')
  }
  const handleFeedback = () => {
    window?.open('https://httishere.notion.site/1bb6ab70c0d646c88459d7e78ff020f4')
  }
  const handleQuestionById = (id: string) => {
    if (!id) return
    navigate(`/qa/${id}`)
  }

  const questions = useMemo(() => {
    return qaList.filter((item) => item?.help)
  }, [])

  const QListItem = (props: any) => {
    const { item } = props
    return (
      <div className="p-2 mb-1 rounded-md flex justify-between w-full hover:bg-gray-100" onClick={() => handleQuestionById(item?.id)}>
        <h4>{item?.help_title || item?.title}</h4>
        <ArrowRightOutlined />
      </div>
    )
  }

  return (
    <Popover
      trigger={['click']}
      content={
        <div
          style={{
            width: 300,
            background: 'linear-gradient(to bottom, #000 40%, #fff 100%)',
            margin: -12,
            borderRadius: 8,
            padding: 12,
            cursor: 'pointer',
          }}
        >
          <h1 className="text-xl text-white">Widverse · 汪汪汪世界</h1>
          <h2 className="text-4xl text-white mt-8">
            Hi there 👋<br></br>How can we help?
          </h2>
          <div className="mt-4 p-4 rounded-md flex bg-white items-center justify-between" onClick={handleMailTo}>
            <p>
              发送邮件 <small className="text-gray-400 ml-2">将在1-2个工作日内回复</small>
            </p>
            <SendOutlined />
          </div>
          <div className="mt-4 p-4 rounded-md flex bg-white items-center justify-between" onClick={handleFeedback}>
            <p>
              直接反馈 <small className="text-gray-400 ml-2">将会定时回复</small>
            </p>
            <QuestionOutlined />
          </div>
          <div className="mt-4 p-2 rounded-md bg-white justify-between shadow-md">
            {questions.map((item) => (
              <QListItem item={item} key={item?.id} />
            ))}
          </div>
        </div>
      }
    >
      <FloatButton icon={<QuestionCircleOutlined />} type="primary" style={{ right: 24 }} />
    </Popover>
  )
}
